// src/utils/leases.js
//
// Lease helpers ported from the legacy monolith.
//
// `getActiveLease` returns the lease the rest of the app should treat as
// "the lease" for display, lease-type filtering, critical-date math, etc.
// Logic mirrors the monolith exactly: prefer status==="active", else fall
// back to the first lease in the array, else null.
//
export function getActiveLease(location) {
  const leases = (location && location.leases) || [];
  return leases.find((l) => l && l.status === "active") || leases[0] || null;
}

// LSE-LOCATIONS-FILTER-MULTI-LEASE: returns ALL distinct active lease types
// for a location, supporting "any active lease of this type" filter semantics.
//
// Two payload shapes:
//   List payload  — no `leases` array; `activeLeaseTypes` is a string[]
//                   populated by the server-side array_agg LATERAL.
//   Detail payload — full `leases` array; derive types from it so the same
//                    helper works on the location detail page without changes.
//
// A location with no active leases returns []. The filter counts such
// locations under All only, matching the #14 spec.
export function getActiveLeaseTypes(location) {
  if (!location) return [];
  if (Array.isArray(location.activeLeaseTypes)) {
    return location.activeLeaseTypes;
  }
  if (Array.isArray(location.leases)) {
    return [...new Set(
      location.leases
        .filter((l) => l && l.status === "active" && !l.deletedAt)
        .map((l) => l.type)
        .filter(Boolean)
    )];
  }
  return [];
}
